import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigTypeEnum, HeaderTitle, TabTypeEnum } from 'src/app/models/generic';
import { DataService } from 'src/app/services/data.service';
import { ITab } from '../../models/tabs';

@Component({
  selector: 'app-configuracoes',
  templateUrl: './configuracoes.component.html',
  styleUrls: ['./configuracoes.component.scss']
})
export class ConfiguracoesComponent implements OnInit {
  tab: ITab[] = [];
  tabEnum = TabTypeEnum;
  configEnum = ConfigTypeEnum;

  actionTab: number | string = 1;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _dataService: DataService
  ) {
    const title = _activatedRoute.snapshot.routeConfig?.title as HeaderTitle;
    this._dataService.setHeaderTitle(title);
  }

  ngOnInit(): void {
    this.generateTabs();
  }

  generateTabs(): void {
    this.tab = [
      { title: 'E-mail', id: 1 },
      { title: 'Parâmetros', id: 2 },
      { title: 'Lote de Repasse', id: 3 },
      { title: 'Loja Própria', id: 4 },
      { title: 'Estorno', id: 5 }
    ];
  }

  changeTabs(tab: number | string): void {
    this.actionTab = tab;
  }
}
